// collection-threshold-popup.js
// Shows a popup once the cart subtotal of items from a chosen collection
// reaches the merchant-configured threshold (quick-cart section settings).

(function () {
  const POPUP_ID = "collection-threshold-popup";
  const SHOWN_KEY = "collectionThresholdPopupShown";

  function getPopup() {
    return document.getElementById(POPUP_ID);
  }

  function getConfig(popup) {
    const threshold = parseFloat(popup.dataset.threshold || "0");
    let productIds = [];
    try {
      productIds = JSON.parse(popup.dataset.collectionProductIds || "[]").map(String);
    } catch (e) {
      productIds = [];
    }
    return { threshold, productIds };
  }

  function showPopup(popup) {
    popup.style.display = "flex";
    requestAnimationFrame(() => popup.classList.add("show"));
    document.body.classList.add("popup-open");
  }

  function closePopup(popup) {
    popup.classList.remove("show");
    document.body.classList.remove("popup-open");
    setTimeout(() => {
      popup.style.display = "none";
    }, 300);
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function checkThreshold() {
    const popup = getPopup();
    if (!popup) return;

    const { threshold, productIds } = getConfig(popup);
    if (!threshold || productIds.length === 0) return;

    fetch(cartRoot() + "cart.js", { headers: { accept: "application/json" } })
      .then((res) => res.json())
      .then((cart) => {
        const subtotal = (cart.items || [])
          .filter((item) => productIds.includes(String(item.product_id)))
          .reduce((sum, item) => sum + item.final_line_price, 0);

        if (subtotal >= threshold) {
          if (sessionStorage.getItem(SHOWN_KEY) !== "true") {
            showPopup(popup);
            sessionStorage.setItem(SHOWN_KEY, "true");
          }
        } else {
          sessionStorage.removeItem(SHOWN_KEY);
        }
      })
      .catch(() => {});
  }

  function isCartMutationUrl(url) {
    return (
      typeof url === "string" &&
      (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update"))
    );
  }

  // Intercept fetch-based cart mutations
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const isCartMutation = isCartMutationUrl(args[0]);
    return originalFetch.apply(this, args).then((response) => {
      if (isCartMutation && response.ok) checkThreshold();
      return response;
    });
  };

  // Intercept XHR-based cart mutations
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._isCartMutation = isCartMutationUrl(url);
    return origOpen.apply(this, arguments);
  };
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._isCartMutation) {
      this.addEventListener("load", function () {
        if (this.status === 200) checkThreshold();
      });
    }
    return origSend.apply(this, arguments);
  };

  document.addEventListener("DOMContentLoaded", function () {
    checkThreshold();

    document.addEventListener("click", function (e) {
      const popup = getPopup();
      if (!popup) return;

      if (e.target.closest("[data-collection-threshold-popup-close]")) {
        closePopup(popup);
      }

      if (e.target.closest("[data-collection-threshold-popup-cta]")) {
        const link = popup.dataset.buttonLink;
        closePopup(popup);
        if (link) window.location.href = link;
      }
    });
  });
})();
